let $math = require('mathjs');
export default class _Math {
    static myIsNaN(value) {
        return typeof value === 'number' && !isNaN(value);
    }
    static add() {
        return this.myIsNaN(this.calculate('add', arguments)) ? this.calculate('add', arguments) : 0;
    }

    static subtract() {
        return this.calculate('subtract', arguments)
    }

    static multiply() {
        return this.myIsNaN(this.calculate('multiply', arguments)) ? this.calculate('multiply', arguments) : 0;
    }

    static divide() {
        return this.myIsNaN(this.calculate('divide', arguments)) ? this.calculate('divide', arguments) : 0;
    }

    static calculate(_func, args) {
        let sunArg = [];
        args = [...args];
        args.forEach(item => {
            if (item === undefined || item == null || item === '') {
                sunArg.push(0)
            } else {
                sunArg.push(item)
            }
        })
        let t = $math.chain($math.bignumber(sunArg[0]));
        for (let i = 1; i < sunArg.length; i++) {
            t = t[_func]($math.bignumber(sunArg[i]))
        }
        // 防止超过6位使用科学计数法
        return parseFloat(t.done())
    }
    static formatNumber(num) {
        if (isNaN(num)) {
            throw new TypeError("num is not a number");
        }

        var groups = (/([\-\+]?)(\d*)(\.\d+)?/g).exec("" + num),
            mask = groups[1],            //符号位 
            integers = (groups[2] || "").split(""), //整数部分 
            decimal = groups[3] || "",       //小数部分 
            remain = integers.length % 3;

        var temp = integers.reduce(function (previousValue, currentValue, index) {
            if (index + 1 === remain || (index + 1 - remain) % 3 === 0) {
                return previousValue + currentValue + ",";
            } else {
                return previousValue + currentValue;
            }
        }, "").replace(/\,$/g, "");
        return mask + temp + decimal;
    }
}


// WEBPACK FOOTER //
// ./src/util/toolClass/math.js